import { render, staticRenderFns } from "./TableRequirementEditor.vue?vue&type=template&id=5202a4b1&scoped=true"
import script from "./TableRequirementEditor.vue?vue&type=script&lang=js"
export * from "./TableRequirementEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5202a4b1",
  null
  
)

export default component.exports